import { useAppSelector } from './useAppSelector';

const useFormId = () => {
  const formId = useAppSelector((state) => state.form.formId);

  return formId;
};

export default useFormId;
